export const en = {
  meta: {
    skip: "Skip to content",
    language: "Language",
    languageName: "English",
    switchTo: "Bahasa Indonesia",
    home: "Home",
    backHome: "Back to the home page",
  },
  brand: {
    organisedBy: "Organised by",
    poweredBy: "Powered by",
  },
  hero: {
    eventName: "Powering the Future of Healthcare",
    register: "Register now",
    signIn: "Already registered? Sign in",
    when: "When",
    where: "Where",
    tbc: "To be confirmed",
    openMap: "Open in Maps",
    time: "{start} – {end} WIB",
    admit: "Admit one",
    daysToGo: "{n} days to go",
    tomorrow: "Tomorrow",
    countdown: "Countdown to the doors opening",
    days: "days",
    hours: "hrs",
    minutes: "min",
    seconds: "sec",
  },
  nav: {
    label: "On this page",
    about: "About",
    theme: "Theme",
    speakers: "Speakers",
    perks: "On the day",
    venue: "Venue",
    register: "Register",
  },
  about: {
    kicker: "About",
    speakers: "speakers on stage",
    hours: "hours, one morning",
    prizeValue: "Doorprizes",
    prize: "Exciting Doorprizes",
  },
  theme: {
    kicker: "The theme",
    title: "Three ideas, one morning",
  },
  speakers: {
    kicker: "Speakers",
    title: "Who you will hear from",
    photoSoon: "Photo coming soon",
    orgs: {
      bpjs: "BPJS Health",
      osi: "Indonesian Cyber People",
    },
  },
  perks: {
    kicker: "On the day",
    title: "Come for the talks. Leave with more.",
    merchTitle: "Get Exclusive Pagelaran Sabang Merauke Merchandise",
    prizeTitle: "Exciting Doorprizes",
    prizeCard: "Door prize",
  },
  venue: {
    kicker: "Venue",
    title: "Where we meet",
    openMap: "Open in Google Maps",
    openMapLabel: "Open {place} in Google Maps",
    mapTitle: "Map of the venue",
  },
  closing: {
    kicker: "Save your seat",
    title: "We look forward to seeing you.",
    body: "Registration takes about a minute. Your QR for the door arrives by email.",
  },
  contact: {
    kicker: "Questions?",
    body: "For more information, contact {name}.",
    bodyWithPhone: "For more information, contact {name} at {phone}.",
    whatsapp: "Chat on WhatsApp",
  },
  flow: {
    start: "Come register with us",
    startBody:
      "{n} short questions, about a minute. Your attendee pack with the QR for the door arrives by email.",
    begin: "Start",
    duration: "About 1 min",
    packByEmail: "QR pass by email",
    pressEnter: "press Enter",
    ok: "OK",
    next: "Next",
    back: "Previous question",
    nextQuestion: "Next question",
    progress: "Question {current} of {total}",
    required: "Required",
    optional: "optional",
    yes: "Yes",
    no: "No",
    typeHere: "Type your answer here…",
    sending: "Sending…",
    saving: "Saving…",
    checking: "Checking…",
    stepAccount: "Account",
    stepCode: "Verify",
    stepProfile: "Profile",
    q: {
      full_name: { title: "What is your full name?", hint: "As it should read on your attendee pack." },
      phone: {
        title: "Your mobile number?",
      },
      email: {
        title: "And your email address?",
        hint: "Your verification code and your attendee pack go here.",
      },
      code: {
        title: "Enter the 6-digit code",
        hint: "We sent it to {email}. It can take a minute to arrive; check your spam folder too.",
        label: "Verification code",
        digit: "Digit {n} of 6",
        resend: "Send a new code",
        resendIn: "New code in {s}s",
        resent: "A new code is on its way. Use the newest email.",
        wrongEmail: "Wrong address? Change it",
        attempts: "{n} attempts left.",
      },
      identity_type: {
        title: "Which describes you best?",
        brand_owner: "I run a business",
        creative_worker: "I work in a creative field",
        professional: "I am a professional",
      },
      company_name: {
        title: "Which institution do you work for?",
        hint: "Hospital, clinic, or organisation.",
      },
      job_title: { title: "What is your position?" },
      community_member: {
        title: "Are you a member of {community}?",
        titleGeneric: "Are you a member of the partner community?",
      },
      personal_instagram: { title: "Your Instagram handle?" },
      how_heard: { title: "How did you hear about this event?" },
      what_excites_you: { title: "What are you hoping to take away?" },
      industry: {
        title: "Which sector are you in?",
        other: "Something else",
        otherPlaceholder: "Describe your sector",
      },
      interests: {
        title: "Which topics interest you?",
        hint: "Choose as many as you like.",
        other: "Something else",
        otherPlaceholder: "Tell us the topic",
      },
      brand_name: { title: "What is your business called?" },
      about_brand: { title: "Tell us about your business." },
      brand_instagram: { title: "Your business's Instagram handle?" },
      consent: {
        title: "One last thing",
        body: "I consent to iForte collecting, storing and processing the personal data I provide for managing my registration, verifying my identity, administering my participation, and sending information and communications about this event. My data will be handled securely and used in accordance with the applicable personal data protection regulations.",
        agree: "I agree",
      },
    },
    choiceKey: "Key {key}",
    done: {
      kicker: "You're registered",
      title: "We look forward to seeing you.",
      body: "Your attendee pack is on its way to {email}: the QR for the door as a PDF, and a calendar file for the day.",
      noEmail: "Nothing in your inbox within 10 minutes? Check spam, or contact {name}.",
      addToCalendar: "The calendar file is in the email",
      qr: "Show the QR from the PDF at the registration desk on the day.",
      manage: "View my registration",
      home: "Back to the event",
    },
  },
  returning: {
    kicker: "Already registered",
    title: "Sign in with your email",
    body: "Use the same address you registered with. We'll send a code to it.",
    email: "Email address",
    send: "Send me a code",
    sent: "If that email is registered, we've sent you a code. Use the same address you registered with.",
    code: "Code",
    verify: "Sign in",
    another: "Use a different email",
    newCode: "Send a new code",
    notRegistered: "Not registered yet?",
    registerInstead: "Register now",
  },
  account: {
    hello: "Hello, {name}",
    loading: "Loading your registration",
    status: "Registration",
    packSent: "Your attendee pack has been sent to {email}.",
    packPending: "Complete your profile and your attendee pack will be sent to {email}.",
    complete: "Complete my profile",
    profile: "Your details",
    edit: "Edit details",
    language: "Email language",
    languageHint:
      "Your reminder and every email from now on will be in this language. Anything already sent stays as it was.",
    languageSaved: "Saved. Emails from now on will be in {lang}.",
    signOut: "Sign out",
    institution: "Institution",
    position: "Position",
    community: "{community} member",
    phone: "Mobile",
    email: "Email",
    notAnswered: "Not answered",
    saved: "Your details are saved.",
    save: "Save details",
    cancel: "Cancel",
  },
  rsvp: {
    kicker: "Sessions",
    title: "Choose your sessions",
    join: "Join",
    joinWaitlist: "Join the waitlist",
    leave: "Leave",
    full: "Full",
    spots: "{n} spots left",
    noLimit: "No limit",
    allDay: "Open all day",
    tbd: "Time to be announced",
    capacityTbd: "Opening soon",
    cancelled: "Called off",
    waitlisted: "On the waitlist, position {n}",
    confirmed: "You're in",
    overlap: "This overlaps with {sessions}.",
    closed: "Session booking has closed.",
    submit: "Submit my sessions",
    saveChanges: "Save changes",
    outcome: {
      pack_queued: "Submitted. Your pass is on its way to {email}.",
      update_queued: "Updated. A new pass is on its way.",
      already_queued: "Already on its way.",
      unchanged: "Nothing changed.",
    },
  },
  walkIn: {
    title: "Walk-in registration",
    body: "Not registered yet? Answer {n} short questions and you are checked in, no email code needed.",
    chip: "Checked in straight away",
    emailHint: "For the event's information. No code is sent.",
    emailTaken: "This email is already registered. Show the QR from your email at the front desk, or tell them your name.",
    closedTitle: "Walk-in registration is closed",
    closedBody: "This form opens on the event day, at the venue. Before then, register online.",
    toRegister: "Register online",
    home: "Back to the event",
    inTitle: "You're checked in",
    againTitle: "You're already checked in",
    inAt: "Checked in at {time}",
    inBody: "Please show this screen to the front desk, then go in once they have verified it.",
    registeredTitle: "You're already registered",
    registeredBody: "This number is already registered, so nothing was changed. Show the QR from your email at the front desk, or tell them your name and they will check you in.",
  },

  survey: {
    title: "Survey & Merchandise",
    body: "Use the email address or phone number you registered with.",
    identifierLabel: "Email or phone number",
    continue: "Continue",
    loading: "Loading the survey",
    notOpenYet: "The survey is not open yet",
    opensAt: "Opens {date}, {time} WIB.",
    closed: "The survey is not open right now.",
    window: "Open {start} – {end} WIB.",
    answeredBefore: "Already answered? Enter your email or phone number to see your QR again.",
    notRegistered:
      "Sorry, your account is not registered in our system. If you believe this is an error, please contact the administrator or front desk for assistance.",
    notVerified:
      "Your registration isn't complete: confirm your email with the code we sent, then try again.",
    toRegister: "Go to registration",
    notReady: "The survey isn't ready yet. Please try again shortly.",
    identifierInvalid: "Enter a valid email address or phone number.",
    rateLimited: "Too many attempts. Please wait a moment and try again.",
    rateLimitedFor: "Too many attempts. Please wait {s} seconds and try again.",
    greeting: "Hi, {first_name}!",
    requiredLegend: "Questions marked * are required.",
    requiredMark: "required",
    ratingValue: "{n} of {max}",
    characters: "{n}/{max}",
    answerRequired: "Please answer this question.",
    answerInvalid: "Please check this answer.",
    answerTooLong: "This answer is too long.",
    otherLabel: "Please specify",
    otherPlaceholder: "Tell us what you mean…",
    otherRequired: "Please tell us what you mean by this choice.",
    fixAnswers: "Some answers need your attention.",
    submit: "Submit answers",
    confirm: "Answers can't be changed after submitting. Submit now?",
    review: "Check again",
    qrInstruction: "Show this QR at the front desk to collect your merchandise",
    qrAlt: "Merchandise QR code",
    saveImage: "Save as image",
    saveHint: "Press and hold the image to save it",
    alreadySubmitted: "You had already filled in the survey; here is your QR.",
    alreadyCollected: "Merchandise already collected",
    collectedAt: "{date}, {time} WIB",
    notYou: "Not you? Use a different email or number",
  },
  toast: {
    close: "Dismiss",
    codeSent: "Code sent",
    codeSentBody: "Check {email}. It can take a minute to arrive.",
    codeResent: "A new code is on its way",
    codeResentBody: "Use the code in the newest email.",
    serverDown: "Can't reach our server",
    saved: "Saved",
    signedOut: "You're signed out",
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    network: "We couldn't reach the server. Check your connection and try again.",
    unreachable:
      "Our server isn't answering right now. Your answers are kept here; please try again in a moment.",
    timeout: "The server took too long to answer. Please try again.",
    rateLimited: "Too many tries. Please wait {s} seconds.",
    rateLimitedShort: "Too many tries. Please wait a moment.",
    retry: "Try again",
    required: "Please answer this question.",
    fullName: "Please enter your full name.",
    phoneInvalid: "That doesn't look like an Indonesian mobile number.",
    emailInvalid: "Please enter a valid email address.",
    emailTaken: "This email is already registered. Sign in with it to manage your registration.",
    signInInstead: "Sign in instead",
    codeShape: "The code is 6 digits.",
    codeWrong: "That code isn't right.",
    codeExpired: "This code has expired. Send a new one.",
    codeLocked: "Too many wrong tries. Send a new code.",
    codeSuperseded: "A newer code was sent. Use the code in the latest email.",
    codeConsumed: "This code has already been used. Sign in to continue.",
    challengeGone: "This registration has expired. Please start again.",
    resendLimit: "You've asked for a lot of codes. Please wait an hour and try again.",
    phoneConflict: "This number can't be used for this registration. Please start again.",
    consentRequired: "Please agree to continue.",
    tooLong: "That's a little long. Please shorten it.",
    sessionExpired: "Your session has ended. Please sign in again.",
    eventNotReady: "Registration isn't open yet. Please check back soon.",
    startOver: "Start again",
  },
  notFound: {
    title: "This page isn't here",
    body: "The link may be old. The event page has everything.",
    home: "Go to the event",
  },
} as const;

export type Dict = typeof en;
